import { StackTitle, appendStackTitlePropsToOptions, type StackTitleProps } from '../StackTitle';

/**
 * @deprecated Use `StackTitleProps` instead.
 */
export type StackScreenTitleProps = StackTitleProps;

/**
 * @deprecated Use `Stack.Title` instead.
 */
export const StackScreenTitle = StackTitle;

/**
 * @deprecated Use `appendStackTitlePropsToOptions` instead.
 */
export const appendStackScreenTitlePropsToOptions = appendStackTitlePropsToOptions;
